import { Component } from 'react';

import { OptionalChildrenProps } from '../../../../types/react.types';
import Dropdown from '../../../ui/dropdown/dropdown';
import styles from './resize-image-download.component.module.scss';

interface ResizeImageDownloadButtonProps extends OptionalChildrenProps {
    showDownload: (event) => void,
    btnSizeClass?: string;
    className?: string;
    style?: React.CSSProperties;
}
export default class ResizeImageDownloadButtonComponent extends Component<ResizeImageDownloadButtonProps> {
    btnSizeClass = 'btn btn-primary btn-sm';
    values: { text: string, tooltip?: string, extension: string }[] = [
        { text: 'Download as JPG', extension: 'jpg' },
        { text: 'Download as PNG', extension: 'png' },
        { text: 'Download as WebP', extension: 'webp' },
        { text: 'Download as TIFF', extension: 'tiff' },
        { text: 'Download as BMP', extension: 'bmp' },
        // values={this.values} label="Extension" onSelect={(e) => this.showDownload.next(e.text)}
    ]

    constructor(props) {
        super(props)
        this.btnSizeClass = `${this.btnSizeClass} ${this.props.btnSizeClass}`;
    }

    downloadRequested(selectedValue) {
        if (selectedValue) {
            this.props.showDownload(selectedValue.extension)
        }
    }

    // TODO Preact missing download icon
    render() {
        return <div className={this.props.className} style={this.props.style || { maxWidth: '260px' }}>
            <Dropdown
                values={this.values}
                selectedValueFormatter={(e) => 'Save'}
                btnGroupClassNames={`${styles['small-btn']}`}
                btnClassNames={this.btnSizeClass}
                onSelect={(e) => this.downloadRequested(e)}
                valueFormatter={(v) => v?.text}
                hasTooltip={(v) => !!v?.tooltip}
                getTooltip={(v) => v?.tooltip}
            ></Dropdown>
        </div>;
    }
}
